import { Option } from '@shared/types/components.type';

export const VISIT_COST_OPTION: Option = {
  label: 'Visit Costs',
  value: 'visits_costs',
};
